export default __webpack_public_path__ + "static/media/bar-chart-icon.b806e8a4.png";